/* eslint-disable react/no-array-index-key */
import { Box, Divider, Grid, Typography } from '@mui/material';
import { memo } from 'react';

import { GroupStatusIcon } from '../../components/StatusIndicators';
import { isGroupComplete } from '../../utils/completionUtils';
import { INF_STATISTIC_FIELD_LABELS } from '../constants';
import { VariableDescriptionSection } from '../types';

interface VariableDescriptionsProps {
  variableDescriptions: VariableDescriptionSection;
}

export const VariableDescriptions = memo(function VariableDescriptions(
  props: VariableDescriptionsProps
) {
  const { variableDescriptions } = props;

  return (
    <Grid id="inf-variables" container spacing={2} marginBottom={3}>
      <Grid item xs={12}>
        <Box display="flex" alignItems="center" gap={1}>
          <GroupStatusIcon
            isComplete={
              isGroupComplete(variableDescriptions.dependent_variable) &&
              (variableDescriptions.independent_variables.length === 0 ||
                isGroupComplete(variableDescriptions.independent_variables))
            }
          />
          <Typography my={2} fontWeight={600}>
            Variáveis
          </Typography>
        </Box>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_STATISTIC_FIELD_LABELS.variable_type}
        </Typography>
        <Typography>dependente</Typography>
      </Grid>
      <Grid item xs={9}>
        <Typography variant="caption" color="text.secondary">
          {INF_STATISTIC_FIELD_LABELS.variable_description}
        </Typography>
        <Typography>
          {variableDescriptions.dependent_variable.description || '-'}
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_STATISTIC_FIELD_LABELS.variable_name}
        </Typography>
        <Typography>
          {variableDescriptions.dependent_variable.name || '-'}
        </Typography>
      </Grid>
      <Grid item xs={3}>
        <Typography variant="caption" color="text.secondary">
          {INF_STATISTIC_FIELD_LABELS.variable_unit}
        </Typography>
        <Typography>
          {variableDescriptions.dependent_variable.unit || '-'}
        </Typography>
      </Grid>
      {variableDescriptions.independent_variables.length > 0 && (
        <Grid item xs={12}>
          <Divider sx={{ width: '100%' }} />
        </Grid>
      )}
      {variableDescriptions.independent_variables.map((item, index) => (
        <Grid item xs={12} key={index}>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <Typography variant="caption" color="text.secondary">
                {INF_STATISTIC_FIELD_LABELS.variable_type}
              </Typography>
              <Typography>independente</Typography>
            </Grid>
            <Grid item xs={9}>
              <Typography variant="caption" color="text.secondary">
                {INF_STATISTIC_FIELD_LABELS.variable_description}
              </Typography>
              <Typography>{item.description || '-'}</Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="caption" color="text.secondary">
                {INF_STATISTIC_FIELD_LABELS.variable_name}
              </Typography>
              <Typography>{item.name || '-'}</Typography>
            </Grid>
            <Grid item xs={3}>
              <Typography variant="caption" color="text.secondary">
                {INF_STATISTIC_FIELD_LABELS.variable_unit}
              </Typography>
              <Typography>{item.unit || '-'}</Typography>
            </Grid>
            {index !==
              variableDescriptions.independent_variables.length - 1 && (
              <Grid item xs={12}>
                <Divider sx={{ width: '100%' }} />
              </Grid>
            )}
          </Grid>
        </Grid>
      ))}
    </Grid>
  );
});
